// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth-card .v-card__title+.v-card__text{padding-top:16px}.auth-card .v-card__actions{padding:16px;gap:1rem}.auth-card__links{display:flex;width:100%}", ""]);
// Exports
module.exports = exports;
